import { safeApiRequest } from './apiClient';
import { sanitizeSearchInput } from '../utils/security';
import { normalizeTurkishPhone } from '../utils/phoneNormalize';

const CUSTOMERS_ENDPOINT = '/api/customers';

/**
 * Müşteri payload'ını oluşturur
 */
const buildCustomerPayload = (payload = {}) => {
  const data = {};

  if (payload.adi !== undefined && payload.adi !== '') {
    data.adi = String(payload.adi).trim().normalize('NFC');
    data.name = data.adi;
  }

  if (payload.soyadi !== undefined && payload.soyadi !== '') {
    data.soyadi = String(payload.soyadi).trim().normalize('NFC');
    data.surname = data.soyadi;
  }

  if (payload.telefon !== undefined && payload.telefon !== '') {
    data.telefon = normalizeTurkishPhone(payload.telefon);
    data.phone = data.telefon;
  }

  if (payload.mail !== undefined && payload.mail !== '') {
    data.mail = String(payload.mail).trim().toLowerCase();
  }

  // cityId, districtId ve adres artık müşteri modelinde değil, adres modelinde
  // Bu alanlar payload'dan kaldırıldı

  if (payload.aktif !== undefined) {
    data.aktif = Boolean(payload.aktif);
  }

  if (payload.isTest !== undefined) {
    data.isTest = payload.isTest === true;
  }

  return data;
};

/**
 * Tüm müşterileri getirir (sayfalama ile)
 */
export const fetchCustomers = async ({ 
  page = 1, 
  limit = 50, 
  aktif = true,
  search 
} = {}) => {
  const queryParams = {};
  
  if (page) {
    queryParams.sayfa = page;
  }
  
  if (limit && limit !== 50) {
    queryParams.limit = limit;
  }
  
  if (aktif === false) {
    queryParams.aktif = 'false';
  }
  
  if (search && search.trim().length > 0) {
    queryParams.arama = sanitizeSearchInput(search);
  }
  
  console.log('[fetchCustomers] Query params:', queryParams);
  
  return safeApiRequest(CUSTOMERS_ENDPOINT, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Müşteri arama
 * Endpoint: GET /api/customers/search
 */
export const searchCustomers = async (arama, { aktif, sayfa, limit } = {}) => {
  if (!arama || arama.trim().length < 3) {
    throw new Error('Arama terimi en az 3 karakter olmalıdır');
  }
  
  const queryParams = {
    arama: sanitizeSearchInput(arama),
  };
  
  if (aktif !== undefined) {
    queryParams.aktif = aktif === true ? 'true' : 'false';
  }
  
  // Pagination parametreleri
  if (sayfa !== undefined && sayfa !== null) {
    queryParams.sayfa = sayfa;
  }
  
  if (limit !== undefined && limit !== null) {
    queryParams.limit = Math.min(limit, 100); // Max 100
  }
  
  console.log('[searchCustomers] Searching with params:', queryParams);
  
  return safeApiRequest('/api/customers/search', {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Müşteri detayı
 */
export const fetchCustomerDetail = async (id) => {
  if (!id) {
    throw new Error('Müşteri ID gereklidir');
  }
  return safeApiRequest(`${CUSTOMERS_ENDPOINT}/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Müşteri oluştur
 */
export const createCustomer = async (payload) => {
  const data = buildCustomerPayload(payload);
  return safeApiRequest(CUSTOMERS_ENDPOINT, {
    method: 'POST',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Müşteri güncelle
 */
export const updateCustomer = async (id, payload) => {
  if (!id) {
    throw new Error('Müşteri ID gereklidir');
  }
  const data = buildCustomerPayload(payload);
  return safeApiRequest(`${CUSTOMERS_ENDPOINT}/${id}`, {
    method: 'PUT',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Müşteri pasif yap / aktif yap
 */
export const toggleCustomerStatus = async (id, aktif) => {
  if (!id) {
    throw new Error('Müşteri ID gereklidir');
  }
  return safeApiRequest(`${CUSTOMERS_ENDPOINT}/${id}`, {
    method: 'PUT',
    body: { aktif: Boolean(aktif) },
    skipCsrf: false,
  });
};

export const sendMusteriIzinOtp = async (musteriId, telefon) => {
  if (!musteriId) throw new Error('Müşteri ID gereklidir');
  return safeApiRequest(`${CUSTOMERS_ENDPOINT}/${musteriId}/iletisim-izni/otp/gonder`, {
    method: 'POST',
    body: telefon ? { telefon } : {},
    skipCsrf: false,
  });
};

export const verifyMusteriIzinOtp = async (musteriId, kod, baglam = {}) => {
  if (!musteriId) throw new Error('Müşteri ID gereklidir');
  const body = { kod };
  if (baglam?.gorusmeKaydiId) body.gorusmeKaydiId = baglam.gorusmeKaydiId;
  if (baglam?.servisKaydiId) body.servisKaydiId = baglam.servisKaydiId;
  return safeApiRequest(`${CUSTOMERS_ENDPOINT}/${musteriId}/iletisim-izni/otp/dogrula`, {
    method: 'POST',
    body,
    skipCsrf: false,
  });
};

export const fetchMusteriIletisimIzniGecmisi = async (musteriId) => {
  if (!musteriId) throw new Error('Müşteri ID gereklidir');
  return safeApiRequest(`${CUSTOMERS_ENDPOINT}/${musteriId}/iletisim-izni/gecmis`, {
    method: 'GET',
    skipCsrf: true,
  });
};

